import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { redirectToStore } from '../../utils/stores';

import mgm from '../../_redux/actions/api/mgm';

import { FaCheck, FaBarcode } from 'react-icons/fa';

import { PageView, initGA } from '../../Components/Tracking';
import stores, { storesRel } from '../../utils/stores';
import MGMButton from '../../Components/MGMButton';

import LogoHeaderDesk from '../../img/logo-yalo-horizontal.png';
import LogoHeader from '../../img/logoyaloverde.png.png';

class Sucesso extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: '',
			plan: ''
		};
	}

	async componentDidMount() {
		const planType = sessionStorage.getItem('planType');
		this.setState({ plan: planType });
		await mgm.loginMgm();
		let store = sessionStorage.getItem('store');
		let { Subscription } = this.props;
		if (!store) {
			store = stores[this.props.match.params.loja];
		}
		const { name: storeName } = storesRel.find(s => s.id == store);

		initGA();
		PageView(`/loja/${storeName}/sucesso`);

		if (planType === 'saude') {
			const payer =
				window.location.hostname === 'localhost'
					? {
							subscriptionId: '32704',
							email: 'ze.ruas@yalo.com.br',
							cpf: '93095135270',
							name: 'Tony Stark',
							lastname: ' ',
							birthday: '1978-09-04',
							gender: 'Male',
							phone: '48999251896',
							addressId: '33499',
							orderId: '27416'
					  }
					: Subscription.data.itens[0];

			if (payer) {
				var formattedName = payer.name.replace(' ', '-').toLowerCase();
				let dataMgm = {
					source: 'MGM',
					medium: payer.cpf,
					campaign: formattedName,
					content: 'pagina-sucesso-compra'
				};
				try {
					const res = await mgm.indication(dataMgm);
					this.setState({ url: res.data });
				} catch (err) {
					console.log(err);
				}
			}
		}
	}

	render() {
		let { Payment, Subscription, Plan } = this.props;
		// let hasUsedCard = Plan.list.some(plan => plan.used_card === '1');
		const planType = sessionStorage.getItem('planType');
		let hasUsedCard = planType == 'saude' ? 1 : 0;
		const store = sessionStorage.getItem('store');

		let mgmBox = (
			<div className='row'>
				<div className='col-sm-12 col-md-12'>
					<MGMButton message={this.state.url} />
				</div>
			</div>
		);

		let successCard = (
			<div className='form-step form-step-6 para-cartao'>
				<div className='row'>
					<div className='success'>
						<div className='row visible-xs visible-sm header'>
							<div className='header-bar header-success'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={90} />
								</a>
							</div>
						</div>
						<div className='row visible-md visible-lg header-success'>
							<div className='header-bar'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={100} />
								</a>
							</div>
						</div>
						<div className='success-content'>
							<div className='success-list'>
								<h2 className='f-bold'>Assinatura contratada com sucesso!</h2>
								<ul>
									<li>
										<FaCheck size={20} color={'#00b3b3'} />
										Sua assinatura já está ativa!
									</li>
									<li>
										<FaCheck size={20} color={'#00b3b3'} />
										Para agendar sua consulta por R$ 40 no dr.consulta acesse
										<a href='https://www.drconsulta.com'>
											{' '}
											www.drconsulta.com{' '}
										</a>
										ou ligue para central de atendimento deles:{' '}
										<a href='tel:40901510'>4090-1510</a>. Você será identificado
										automaticamente como cliente YALO pelo seu CPF.
									</li>
									{hasUsedCard ? (
										<li>
											<FaCheck size={20} color={'#00b3b3'} />
											Seu cartão chegará em até 10 dias úteis.
										</li>
									) : (
										''
									)}
								</ul>
							</div>
							<br />
							<br />
							{this.state.plan === 'saude' ? (
								<div className='success-list1 text-center'>
									<h2 className='f-bold'>Que tal se cuidar de graça?</h2>
									<p>
										Investimos na sua saúde para cada indicação que contratar o{' '}
										<b>yalo saúde</b>!
									</p>
									<p>
										<span className='f-bold'>R$ 10</span> para você e{' '}
										<span className='f-bold'>R$ 10</span> para seus amigos
									</p>

									<p>
										O dinheiro é creditado nos cartões <b>yalo</b>, sem limites
										de indicações!
									</p>

									{mgmBox}
								</div>
							) : (
								''
							)}
							<br />
							<br />
						</div>
					</div>
				</div>
			</div>
		);
		let quaseCard = (
			<div className='form-step form-step-6 para-cartao'>
				<div className='row'>
					<div className='success'>
						<div className='row visible-xs visible-sm header-success'>
							<div className='header-bar'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={90} />
								</a>
							</div>
						</div>
						<div className='row visible-md visible-lg header-desk-success'>
							<div className='header-bar'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={100} />
								</a>
							</div>
						</div>

						<div className='success-content'>
							<div className='success-list'>
								<h2 className='f-bold'>Pedido realizado com sucesso</h2>
								<ul>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Seu pedido está sendo processado. Fique tranquilo que vamos
										te notificar do resultado da sua compra por email e SMS.
									</li>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Informaremos se a cobrança foi realizada com sucesso ou não.
										Em caso de falha, você poderá realizar a compra novamente.
									</li>
									{hasUsedCard ? (
										<li>
											<FaCheck size={20} color={'#fff'} />
											Após a confirmação do pagamento o cartão chega em até 10
											dias úteis.
										</li>
									) : (
										''
									)}
								</ul>

								<br />
								<p>
									<span></span>
								</p>
								<br />
							</div>
						</div>
					</div>
				</div>
			</div>
		);

		let boletoBtn = '';
		if (Payment.data.boletoPDF) {
			boletoBtn = (
				<div className='text-center'>
					<br />
					<a
						href={Payment.data.boletoPDF}
						className='button-download'
						target='_blank'
						rel='noopener noreferrer'>
						<FaBarcode /> &nbsp; Ver Boleto
					</a>
				</div>
			);
		}

		let sendedEmail = '';
		if (Subscription.data.itens.length) {
			sendedEmail = Subscription.data.itens[0].email;
		}

		let successBoleto = (
			<div className='form-step form-step-6 para-boleto'>
				<div className='row'>
					<div className='success'>
						<div className='row visible-xs visible-sm header-success'>
							<div className='header-bar'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={90} />
								</a>
							</div>
						</div>
						<div className='row visible-md visible-lg header-desk-success'>
							<div className='header-bar'>
								<a onClick={() => redirectToStore()}>
									<img src={LogoHeaderDesk} alt='' width={100} />
								</a>
							</div>
						</div>

						<div className='success-content'>
							<div className='success-list'>
								<h2 className='f-bold'>Pedido realizado com sucesso</h2>
								<ul>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Seu boleto foi emitido com sucesso e enviado para o email e
										telefone cadastrados.
									</li>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Sua assinatura será ativada assim que recebermos a
										confirmação do pagamento. Isso pode demorar até dois dias
										úteis.
									</li>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Enviaremos um email e um SMS confirmando sua ativação.
									</li>
									<li>
										<FaCheck size={20} color={'#fff'} />
										Você poderá agendar consultas por R$ 40 no dr.consulta logo
										após receber essa confirmação.
									</li>
									{hasUsedCard ? (
										<li>
											<FaCheck size={20} color={'#fff'} />
											Seu cartão <b>yalo</b> chegará em até dez dias úteis após
											sua ativação, mas não se preocupe, para seus descontos
											você só vai precisar do seu CPF.
										</li>
									) : (
										''
									)}
								</ul>
								{boletoBtn}
							</div>
							<br />
							<br />
						</div>
					</div>
				</div>
			</div>
		);

		let successReponse = '';
		if (Payment.data.paymentMethod === 'boleto') {
			successReponse = successBoleto;
		} else if (Payment.data.status === 'paid') {
			successReponse = successCard;
		} else {
			successReponse = quaseCard;
		}
		return (
			<div className='form-wrapper'>
				<div className='container-fluid'>
					<div className='row'>
						<div className='col-xs-12 col-md-offset-3 col-change col-md-9'>
							{successReponse}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Sucesso);
